import './listpic.scss';
import Sloth from '../Sloth';



/** WEBPACK FOOTER **
 ** ./components/Listpic/listpic.js
 **/